import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Singleton } from "../../../../../core/services/Singleton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _SecuritySpreadSheetProcess } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { AdminProcess } from "../../../../erp/cellEditor/PaymentHeader/AdminProcess";


interface Props {
    idSocialSecurityTemplate: number;
}

export const SecuritySpreadSheetProcess = ({ idSocialSecurityTemplate }: Props) => {

    const template = useDataBean(_SecuritySpreadSheetProcess);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idSocialSecurityTemplate])

    const getLista = () => {

        template.instance.getSocialSecuritySpreadSheetProcessCatalog(idSocialSecurityTemplate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        // template.setBean({
        //     IDSocialSecurityTemplate: idSocialSecurityTemplate
        // });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        template.instance.deleteSocialSecuritySpreadSheetProcess(template.bean.IDSocialSecuritySpreadSheetProcess).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        template.instance.addSocialSecuritySpreadSheetProcess(idSocialSecurityTemplate, template.bean.IDProcess, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSocialSecuritySpreadSheetProcess', visible: true },
        { title: 'ID Proceso', property: 'IDProcess', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo Proceso', property: 'TypeName', visible: true },
        { title: 'Tipo', property: 'SubtypeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={template.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <AdminProcess returnType="ID" processType={4} idSelector={template.bean.IDProcess} label="Proceso" onChange={(e) => { template.setBean({ ...template.bean, 'IDProcess': e.IDProcess }) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}